import type { Comic } from "@/mocks/comics";
import type { NewsItem } from "@/mocks/news";

const chapterSubtitles = [
  "森林的低语",
  "初次相遇",
  "月光下的约定",
  "被遗忘的名字",
  "风起之时",
  "遥远的回响",
  "沉睡的记忆",
  "交错的命运",
  "黎明前的道别",
  "重新出发",
  "安静的守望",
  "星辰落下的地方",
];

export interface ComicChapter {
  no: number;
  title: string;
  date: string;
}

function formatDate(time: number): string {
  const d = new Date(time);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function generateChapters(latestChapter: number, updatedAt: string, count = 10): ComicChapter[] {
  const base = new Date(`${updatedAt}T00:00:00`).getTime();
  const list: ComicChapter[] = [];
  for (let i = 0; i < count; i += 1) {
    const no = latestChapter - i;
    if (no < 1) break;
    const date = Number.isNaN(base) ? updatedAt : formatDate(base - i * 7 * 86400000);
    list.push({
      no,
      title: chapterSubtitles[no % chapterSubtitles.length],
      date,
    });
  }
  return list;
}

export function getComicById(comics: Comic[], id?: string): Comic | undefined {
  if (!id) return undefined;
  return comics.find((c) => c.id === id);
}

export function getRelatedComics(all: Comic[], current: Comic, count = 4): Comic[] {
  const sameCategory = all.filter((c) => c.id !== current.id && c.category === current.category);
  const others = all.filter((c) => c.id !== current.id && c.category !== current.category);
  return [...sameCategory, ...others].slice(0, count);
}

export function getRelatedNews(all: NewsItem[], current: NewsItem, count = 3): NewsItem[] {
  const sameType = all.filter((n) => n.id !== current.id && n.type === current.type);
  const others = all.filter((n) => n.id !== current.id && n.type !== current.type);
  return [...sameType, ...others].slice(0, count);
}

export function matchComic(comic: Comic, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return false;
  const haystack = [comic.title, comic.author, comic.category, comic.intro, ...comic.tags]
    .join(" ")
    .toLowerCase();
  return haystack.includes(q);
}

export function matchNews(item: NewsItem, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return false;
  const body = item.content.map((s) => s.text || "").join(" ");
  const haystack = [item.title, item.author, item.type, item.excerpt, body].join(" ").toLowerCase();
  return haystack.includes(q);
}